module.exports = __webpack_public_path__ + "img/def-st.40f2a1f3.jpg";